<template>
    <LayoutBase>
        <post-chronological :key="post.id" :post="post" :group="group" v-if="group.type == 1"></post-chronological>
        <post-knowledge-base :key="post.id" :post="post" :group="group" v-if="group.type == 2" :category="category"></post-knowledge-base>
        <post-files :key="post.id" :post="post" :group="group" v-if="group.type == 3"></post-files>
        <post-events :key="post.id" :post="post" :group="group" v-if="group.type == 4"></post-events>
        <post-forum :key="post.id" :post="post" :group="group" v-if="group.type == 5"></post-forum>
    </LayoutBase>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex';
    import LayoutBase from '../../layouts/LayoutBase';
    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                post: {
                    title: "",
                    group: {
                        slug: null
                    },
                    reactions: {
                        user_thumbs_up: 0,
                        user_clap: 0,
                        user_love: 0
                    },
                    can: {
                        edit: false
                    }
                },
                category: null
            }
        },
        computed: {
            ...mapState({
                group: state => state.group.group,
                team: state => state.auth.team
            })
        },
        created(){
            this.getGroup( this.$route.params.group );
        },
        mounted() {
            
            if( this.$route.params.category ) {
                this.category = this.$route.params.category;
                this.$store.commit('group/setActiveCategory', this.$route.params.category);
            }

            //if(this.group.name === null){
                //if(this.group.slug != this.$route.params.group){
                //}
            //}

            this.getPost();
        },
        beforeRouteUpdate(to, from, next) {
            this.$route.params.post = to.params.post;
            this.getPost();
            next();
        },
        methods: {
            ...mapActions({
                getGroup: 'group/getGroup',
                clearGroup: 'group/clearGroup'
            }),
            getPost() {
                axios.get('/api/groups/' + this.$route.params.group + "/posts/" + this.$route.params.post).then((response) => {
                    this.post = response.data;
                    document.title = this.post.title + " - " + this.team.name;
                }, (response) => {
                    this.error = response;
                });
            },
        }
    }
</script>